import * as angular from "angular";
import {IController, IQService, ITimeoutService} from "angular";
import * as _ from "lodash";
import {BillingOrderService} from "../../../billing-accounts/services/billing-order.service";
import {LocationType} from "../../../commons/types/location.type";
import {PriceType} from "../../../price-plan/types/price.type";
import {FulfillmentLineType} from "../../types/fulfillment-line.type";
import {SplitService} from "../../../commons/services/split-service.service";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {OmsDialogService} from "../../services/oms-dialog-service.service";
import {OmsOrdersAlertsService} from "../../services/oms-orders-alerts.service";
import {OmsRequestsService} from "../../services/oms-requests.service";
import {OmsService} from "../../services/oms-service.service";
import {AccountModel} from "../../../account/angular/models/account.model";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {SiteContextService} from "../../../commons/services/site-context.service";
import {FulfillmentStepType} from "../../../fulfillment/types/fulfillment-step.type";


export class OmsOrderCreateViewComponent implements IController {

  order: any;
  account: AccountModel;
  isDialog?: boolean;
  isPrefilled?: boolean;
  onCreated?: Function;
  onCancel?: Function;
  onAdvanced?: Function;

  public isDuplicate: boolean = false;
  public numberOfDuplicateCopies: number;
  public siteInfo: any;
  public orderCopy: any;
  public sections: any;
  public pickupDepotIds: string[];
  public accountBranchIds: string[];
  public addMarkerPurpose: any;
  public dueTo: any;
  public submitting = false;
  public customAddressEnabled: boolean;
  public addMarker: any;
  public includePriceForOms: boolean;
  public priceOffer: any;
  public priceOfferCopy: any;
  public isPriceOfferEditMode: boolean;
  public canCreateTag: boolean;
  public proxyProviderType: any;
  public callContactUsingProxyByDefaultValue: boolean;
  public priceTypes: typeof PriceType = PriceType;
  public fulfillmentLineType: typeof FulfillmentLineType = FulfillmentLineType;
  public isInvalidForm: boolean;
  public isReferenceIdsMandatory: boolean;
  public orderAccount: any;
  public depotsRef: any;
  public isOrderExternalIdIsMandatory: boolean;
  public isOmsPackageDimensionMandatory: boolean;
  public isShowSplit: boolean;
  public splitSettings: {} = {};
  public splitLineExpandMap: {} = {};
  public fulfillmentStepType: typeof FulfillmentStepType = FulfillmentStepType;

  constructor(private bringozLoaderService: BringozLoaderService, private $state, private IAMPermissions,
              private omsRequestsService: OmsRequestsService, private omsOrdersAlertsService: OmsOrdersAlertsService, private moment,
              private omsService: OmsService, private commonsAlertsService: CommonsAlertsService, private omsDialogService: OmsDialogService,
              private $q: IQService, private billingOrderService: BillingOrderService,
              private splitService: SplitService, private siteContextService: SiteContextService, private $timeout: ITimeoutService,
              private $depots, private $filter) {

    this.depotsRef = this.$depots();
    this.dueTo = moment().endOf('day').set({'minute': 30, 'second': 0, 'millisecond': 0}).toDate();
  }

  $onInit() {
    this.canCreateTag = this.IAMPermissions.hasPermission('infoTags.create');
    this.siteInfo = this.siteContextService.getSiteInfo();
    this.includePriceForOms = this.siteInfo.priceDetailsForOmsOrder;
    this.proxyProviderType = this.siteInfo.proxyProviderType;
    this.callContactUsingProxyByDefaultValue = this.siteInfo.callContactUsingProxyByDefault;
    this.isPriceOfferEditMode = false;
    this.addMarkerPurpose = undefined;
    this.customAddressEnabled = false;
    this.addMarker = {enabled: false};
    this.isOrderExternalIdIsMandatory = this.splitService.getIsOrderExternalIdIsMandatory();
    this.isOmsPackageDimensionMandatory = this.splitService.getIsOmsPackageDimensionMandatory();

    if (!this.order) {
      this.order = {
        accountId: _.get(this.account, 'id'),
        fulfillmentLines: [
          {
            id: 1,
            type: "Delivery",
            price: undefined,
            packageList: [],
            itemIds: [],
            pickupTask: {
              purpose: "Pickup",
              contact: {},
              location: {
                locationType: "CUSTOM",
                address: {
                  entryId: undefined, //depotId/customerId
                }
              },
              useProxyCall: this.callContactUsingProxyByDefaultValue
            },
            destinationTask: {
              purpose: "Dropoff",
              contact: {},
              location: {
                locationType: "CUSTOM",
                address: {
                  entryId: undefined, //depotId/customerId
                }
              },
              useProxyCall: this.callContactUsingProxyByDefaultValue
            }
          }
        ],
        itemLines: []
      }
      this.order.metaData = this.splitService.getOmsMetadataSettings();
    } else if (this.isPrefilled) {
      // Order carried over from the basic order creation dialog ("Advanced")
      this.orderAccount = this.order.accountReference;
    } else {
      this.isDuplicate = true;
      this.numberOfDuplicateCopies = 1;
      if (_.get(this.order, 'accountId')) {
        this.orderAccount = this.order.accountReference;
        this.order.externalId = undefined;
        _.forEach(this.order.fulfillmentLines, (line) => {
          _.unset(line, 'cancelled');
        })
      }
      this.order.branchesIds = undefined;
      const metaDataCopy = [];
      this.splitService.getOmsMetadataSettings().forEach((item: any) => {
        const itemCopy = angular.copy(item);
        const metaData = this.order.metaData.find(i => {
          return i.key === item.key;
        })
        if (metaData) {
          itemCopy.value = metaData.value;
        }

        metaDataCopy.push(itemCopy);
      })

      this.order.metaData = metaDataCopy;

    }

    if (!!this.account) {
      this.onAccountSelect(this.account);
    }
    this.isReferenceIdsMandatory = this.splitService.isReferenceIdsMandatory();
  }

  onAccountSelect(account: AccountModel) {

    const orderCopy = angular.copy(this.order);
    this.orderAccount = account;

    if (_.get(account, 'id')) {
      orderCopy.fulfillmentLines[0].programType = undefined;
      orderCopy.fulfillmentLines[0].programName = undefined;
    }


    orderCopy.accountId = _.get(account, 'id');
    this.pickupDepotIds = _.get(account, 'depotIds');
    this.accountBranchIds = _.get(account, 'branchIds');
    orderCopy.itemLines = [];
    orderCopy.fulfillmentLines.splice(1, this.order.fulfillmentLines.length);

    const defaultDepotId = _.get(account, 'defaultDepotId');

    const pickupTask = orderCopy.fulfillmentLines[0].pickupTask;
    const isAccountChanged = !!this.order.accountId && this.order.accountId !== account?.id;
    if (isAccountChanged || !pickupTask.notes) {
      pickupTask.notes = defaultDepotId ? undefined : account?.note;
    }

    if (defaultDepotId) {
      this.depotsRef.$asyncValues([defaultDepotId])
        .then((depots) => {
          orderCopy.fulfillmentLines[0].pickupTask.contact.name = _.get(depots[0], 'name');
          orderCopy.fulfillmentLines[0].pickupTask.contact.businessName = _.get(depots[0], 'name');
          orderCopy.fulfillmentLines[0].pickupTask.contact.phoneNo = _.get(depots[0], 'phoneNumber');
          orderCopy.fulfillmentLines[0].pickupTask.contact.additionalPhoneNo = this.$filter('bringozPhone')(_.get(depots[0], 'additionalPhoneNo'));
          orderCopy.fulfillmentLines[0].pickupTask.location.id = _.get(depots[0], 'id');
          orderCopy.fulfillmentLines[0].pickupTask.location.locationType = LocationType.DEPOT;
          orderCopy.fulfillmentLines[0].pickupTask.location.address = _.get(depots[0], 'address', {});

          this.order = orderCopy;
        })

    } else {
      orderCopy.fulfillmentLines[0].pickupTask.contact.name = _.get(account, 'name');
      orderCopy.fulfillmentLines[0].pickupTask.contact.businessName = _.get(account, 'name');
      orderCopy.fulfillmentLines[0].pickupTask.contact.phoneNo = _.get(account, 'phoneNumber');
      orderCopy.fulfillmentLines[0].pickupTask.location.id = _.get(account, 'id');
      orderCopy.fulfillmentLines[0].pickupTask.location.locationType = account ? LocationType.ACCOUNT : undefined;
      orderCopy.fulfillmentLines[0].pickupTask.location.address = _.get(account, 'address', {});

      this.order = orderCopy;
    }

  }

  onNumberOfDuplicateCopiesChange(numberOfDuplicateCopies) {
    if (numberOfDuplicateCopies > 1) {
      this.order.externalId = undefined;
    }
  }

  // onPricePlanChange(fulfillmentLine) {
  //   this.order.itemLines = _.filter(this.order.itemLines, item => {
  //     return !_.includes(fulfillmentLine.itemIds, item.id);
  //   })
  //   const fulfillmentLinesCopy = angular.copy(this.order.fulfillmentLines);
  //   const fulfillmentLineIndex = _.findIndex(this.order.fulfillmentLines, (item: any) => {
  //     return item.id === fulfillmentLine.id;
  //   });
  //   fulfillmentLinesCopy[fulfillmentLineIndex].itemIds = [];
  //   this.order.fulfillmentLines = fulfillmentLinesCopy;
  // }

  onTogglePriceOfferEditMode() {
    this.isPriceOfferEditMode = !this.isPriceOfferEditMode;
    this.orderCopy = this.isPriceOfferEditMode ? angular.copy(this.order) : undefined;
    this.priceOfferCopy = this.isPriceOfferEditMode ? angular.copy(this.priceOffer) : undefined;
  }

  onToggleCustomAddress(purpose) {
    this.addMarkerPurpose = _.isEqual(this.addMarkerPurpose, purpose) ? undefined : purpose;
  }

  //Same
  onBackToOrderView() {
    this.isShowSplit = false;
    this.priceOffer = undefined;
    this.priceOfferCopy = undefined;
    this.orderCopy = undefined;
    this.isPriceOfferEditMode = false;
  }

  onAddPackages(items, fulfillmentLineId) {
    const orderCopy = angular.copy(this.order);

    orderCopy.itemLines = this.order.itemLines.concat(angular.copy(items));
    this.order = orderCopy;

    this.$timeout(() => {
      const lineAddPackageSection = document.getElementById(`add-package-${fulfillmentLineId}`);
      lineAddPackageSection.scrollIntoView({behavior: "smooth", block: "end"});

    }, 1);
  }

  onRemovePackage(itemId) {
    this.order.itemLines = _.filter(this.order.itemLines, (i) => {
      return i.id !== itemId;
    })
  }

  onPackageChange(packageItem) {

    const orderCopy = angular.copy(this.order);
    const packageItemIndex = _.findIndex(orderCopy.itemLines, (i: any) => {
      return i.id === packageItem.id;
    })
    orderCopy.itemLines[packageItemIndex] = packageItem;
    this.order = orderCopy;
  }

  updateOrder(updatedOrder) {
    this.orderCopy = updatedOrder;
  }

  updatePriceOffer(updatedPriceOffer) {
    this.priceOfferCopy = updatedPriceOffer;
  }

  onTagsChange(tagNames) {
    this.order.tags = tagNames;
  }

  onReferenceIdsChange(referenceIds) {
    this.order.referenceIds = referenceIds;
  }

  onFulfillmentLineTypeChange(lineType, fulfillmentLine?) {
    if (fulfillmentLine.type === lineType) {
      return;
    }
    let fulfillmentLinesCopy = angular.copy(this.order.fulfillmentLines);
    let updatedFulfillmentLine = {
      ...fulfillmentLine,
      type: lineType,
      price: undefined,
      packageList: [],
      programType: undefined,
      programName: undefined,
      itemIds: [],
      blockedByLines: [],
      pickupTask: {
        purpose: "Pickup",
        notBefore: undefined,
        notAfter: undefined,
        contact: {
          name: undefined,
          businessName: undefined,
          phoneNo: undefined
        },
        location: {
          id: undefined,
          locationType: "CUSTOM",
          address: {
            entryId: undefined, //depotId/customerId
          }
        },
        useProxyCall: this.callContactUsingProxyByDefaultValue,
        schedulingRequired: false,
        obligateTimeWindow: false
      },
      destinationTask: {
        purpose: "Dropoff",
        notBefore: undefined,
        notAfter: undefined,
        contact: {},
        location: {
          locationType: "CUSTOM",
          address: {
            entryId: undefined, //depotId/customerId
          }
        },
        useProxyCall: this.callContactUsingProxyByDefaultValue,
        schedulingRequired: false,
        obligateTimeWindow: false
      }
    }

    if (lineType === this.fulfillmentLineType.Operation) {
      _.unset(updatedFulfillmentLine, 'pickupTask');
    } else {
      updatedFulfillmentLine.pickupTask.contact.name = _.get(this.orderAccount, 'name');
      updatedFulfillmentLine.pickupTask.contact.businessName = _.get(this.orderAccount, 'name');
      updatedFulfillmentLine.pickupTask.contact.phoneNo = _.get(this.orderAccount, 'phoneNumber');
      updatedFulfillmentLine.pickupTask.location.id = _.get(this.orderAccount, 'id');
      updatedFulfillmentLine.pickupTask.location.locationType = this.orderAccount ? LocationType.ACCOUNT : undefined;
      updatedFulfillmentLine.pickupTask.location.address = _.get(this.orderAccount, 'address', {});
    }

    const fulfillmentLineIndex = _.findIndex(this.order.fulfillmentLines, (item: any) => {
      return item.id === fulfillmentLine.id;
    })
    fulfillmentLinesCopy[fulfillmentLineIndex] = updatedFulfillmentLine;
    this.order.fulfillmentLines = fulfillmentLinesCopy;
  }

  onAddLine(lineType, fulfillmentLine?) {
    let newFulfillmentLine = {
      id: this.order.fulfillmentLines.length + 1,
      type: lineType,
      price: undefined,
      packageList: [],
      programType: undefined,
      programName: undefined,
      itemIds: [],
      blockedByLines: [],
      pickupTask: {
        purpose: "Pickup",
        notBefore: undefined,
        notAfter: undefined,
        contact: {
          name: undefined,
          businessName: undefined,
          phoneNo: undefined
        },
        location: {
          id: undefined,
          locationType: "CUSTOM",
          address: {
            entryId: undefined, //depotId/customerId
          }
        },
        useProxyCall: this.callContactUsingProxyByDefaultValue,
        schedulingRequired: false,
        obligateTimeWindow: false
      },
      destinationTask: {
        purpose: "Dropoff",
        notBefore: undefined,
        notAfter: undefined,
        contact: {},
        location: {
          locationType: "CUSTOM",
          address: {
            entryId: undefined, //depotId/customerId
          }
        },
        useProxyCall: this.callContactUsingProxyByDefaultValue,
        schedulingRequired: false,
        obligateTimeWindow: false
      }
    }
    if (lineType === this.fulfillmentLineType.Delivery || lineType === this.fulfillmentLineType.Exchange) {
      newFulfillmentLine.pickupTask.contact.name = _.get(this.orderAccount, 'name');
      newFulfillmentLine.pickupTask.contact.businessName = _.get(this.orderAccount, 'name');
      newFulfillmentLine.pickupTask.contact.phoneNo = _.get(this.orderAccount, 'phoneNumber');
      newFulfillmentLine.pickupTask.location.id = _.get(this.orderAccount, 'id');
      newFulfillmentLine.pickupTask.location.locationType = this.orderAccount ? LocationType.ACCOUNT : undefined;
      newFulfillmentLine.pickupTask.location.address = _.get(this.orderAccount, 'address', {});
    }
    if (lineType === this.fulfillmentLineType.ReturnDelivery) {
      newFulfillmentLine.blockedByLines.push(fulfillmentLine.id);
      newFulfillmentLine.pickupTask = angular.copy(fulfillmentLine.destinationTask);
      newFulfillmentLine.pickupTask.purpose = 'Pickup';
      newFulfillmentLine.destinationTask = angular.copy(fulfillmentLine.pickupTask);
      newFulfillmentLine.destinationTask.purpose = 'Dropoff';
      newFulfillmentLine.destinationTask.notBefore = newFulfillmentLine.pickupTask.notBefore;
      newFulfillmentLine.destinationTask.notAfter = newFulfillmentLine.pickupTask.notAfter;
      newFulfillmentLine.destinationTask.schedulingRequired = newFulfillmentLine.pickupTask.schedulingRequired;
      newFulfillmentLine.programType = angular.copy(fulfillmentLine.programType);
      newFulfillmentLine.programName = angular.copy(fulfillmentLine.programName);

    }
    if (lineType === this.fulfillmentLineType.Operation) {
      newFulfillmentLine.blockedByLines.push(fulfillmentLine.id);
      _.unset(newFulfillmentLine, 'pickupTask');
      newFulfillmentLine.destinationTask = angular.copy(fulfillmentLine.destinationTask);
      newFulfillmentLine.destinationTask.purpose = "Operation"
    }

    _.forEach(fulfillmentLine?.itemIds, id => {
      let newItem;
      const item = _.find(this.order.itemLines, item => {
        return item.id === id;
      });
      newItem = angular.copy(item);
      const newItemId = 'line_' + newFulfillmentLine.id + '_' + (newFulfillmentLine?.itemIds ? newFulfillmentLine.itemIds.length : '0');
      newItem.id = newItemId;
      newFulfillmentLine.itemIds.push(newItemId);
      this.order.itemLines.push(newItem);
    })
    this.order.fulfillmentLines.push(newFulfillmentLine);
  }

  onRemoveLine(fulfillmentLineId) {
    const fulfillmentLineIndex = _.findIndex(this.order.fulfillmentLines, (item: any) => {
      return item.id === fulfillmentLineId;
    })
    this.order.itemLines = _.filter(this.order.itemLines, item => {
      return !_.includes(this.order.fulfillmentLines[fulfillmentLineIndex].itemIds, item.id);
    })
    this.order.fulfillmentLines.splice(fulfillmentLineIndex, 1);
  }

  onFulfillmentLineChange(fulfillmentLine) {
    const fulfillmentLinesCopy = angular.copy(this.order.fulfillmentLines);
    const fulfillmentLineIndex = _.findIndex(this.order.fulfillmentLines, (item: any) => {
      return item.id === fulfillmentLine.id;
    })
    fulfillmentLinesCopy[fulfillmentLineIndex] = fulfillmentLine;
    this.order.fulfillmentLines = fulfillmentLinesCopy;
  }

  onCancelClick() {
    if (this.isDialog) {
      this.onCancel();
    } else {
      this.$state.go('orders.table');
    }
  }

  onAdvancedClick() {
    this.onAdvanced({order: {...angular.copy(this.order), accountReference: this.orderAccount}});
  }

  onSaveDraft() {
    if (this.isDuplicate && this.numberOfDuplicateCopies > 1) {
      this._onDuplicateOrder(true)
    } else {
      this.submitting = true;
      const orderCopy = angular.copy(this.order);
      orderCopy.metaData = _.chain(orderCopy.metaData)
        .filter(item => {
          return item.value;
        })
        .map(item => {
          return {
            key: item.key,
            value: item.value
          }
        })
        .value();

      this.omsRequestsService.createOrder(orderCopy, true)
        .then((createdOrder) => {
          if (this.isDialog) {
            this.onCreated({order: createdOrder, isDraft: true});
          } else {
            this.omsOrdersAlertsService.createDraftSuccess();
            this.$state.go('order.info', {id: createdOrder.id}, {notify: true, reload: false});
          }
        })
        .catch(() => {
          this.omsOrdersAlertsService.createDraftError();
        })
        .finally(() => {
          this.bringozLoaderService.off();
          this.submitting = false;
        });
    }
  }

  onSubmitPriceOffer(form, doDispatch) {
    form.$setSubmitted(true);
    if (form.$valid) {
      if (this.isPriceOfferEditMode) {
        this._createOrder(this.orderCopy, doDispatch, this.priceOfferCopy);
      } else {
        this._createOrder(this.order, doDispatch, this.priceOffer);
      }
    } else {
      this.commonsAlertsService.formInvalidInfo();
    }
  }

  onSubmitForm(form, isSplit: boolean) {
    this.isInvalidForm = false;

    this.$timeout(0).then(() => {
      form.$setSubmitted(true);

      _.forEach(this.order.fulfillmentLines, (fulfillmentLine, index) => {
        const lineForm = `line_${index}`;
        form[lineForm].$setSubmitted();

        if (!!form[lineForm].Origin) {
          form[lineForm].Origin.$setSubmitted();
        }

        if (!!form[lineForm].Destination) {
          form[lineForm].Destination.$setSubmitted();
        }
      });

      if (form.$valid) {
        if (this.isDuplicate && this.numberOfDuplicateCopies > 1) {
          if (isSplit) {
            this.isShowSplit = true;
            this._initSplitSettings();
          } else {
            this._onDuplicateOrder(false);
          }
        } else {
          this._onCreateOrder();
        }
      } else {
        this.commonsAlertsService.formInvalidInfo();
        this.isInvalidForm = true;
      }
    })
  }

  onLineSplitSettingsChange(settings, lineId: string) {
    this.splitSettings[lineId] = settings;
  }

  onSubmitSplitAndDuplicate(form) {
    if (form.$valid) {
      this._onSubmitSplitAndDuplicate();
    } else {
      this.commonsAlertsService.formInvalidInfo();
    }
  }

  private _initSplitSettings() {
    this.order.fulfillmentLines.forEach((fulfillmentLine) => {

      if (fulfillmentLine.type === this.fulfillmentStepType.Operation) {
        return;
      }

      this.splitSettings[fulfillmentLine.id] = {
        type: 'byLegs',
        location: {
          locationType: 'ACCOUNT'
        }
      }
      this.splitLineExpandMap[fulfillmentLine.id] = false;
    })
  }

  private _onSubmitSplitAndDuplicate() {
    this.submitting = true;

    const payload = {
      omsOrder: this.order,
      splitSettingsByLine: {}
    }

    for (const key in this.splitSettings) {
      if (this.splitSettings[key].location.address || this.splitSettings[key].location.id) {
        payload.splitSettingsByLine[key] = {
          type: this.splitSettings[key].type,
          byLegsPayload: [{
            ...this.splitSettings[key]
          }]
        }
      }
    }

    this.order.metaData = _.chain(this.order.metaData)
      .filter(item => {
        return item.value;
      })
      .map(item => {
        return {
          key: item.key,
          value: item.value
        }
      })
      .value();
    this.omsRequestsService.createMultipleWithSettings(payload, this.numberOfDuplicateCopies)
      .then((res) => {
        this.omsOrdersAlertsService.createSuccess();
        this.$state.go('orders.table');
      })
      .catch((error) => {
        this.omsOrdersAlertsService.createError(error);
      })
      .finally(() => {
        this.submitting = false;
      });
  }

  private _onCreateOrder() {
    let isValidServiceArea;
    this.submitting = true;
    this.omsService.validateOmsOrderServiceAreas(this.order)
      .then((isValid) => {
        isValidServiceArea = isValid;
        const isPricingEnabled = (this.IAMPermissions.hasPermission('priceplan.list') && !!this.includePriceForOms);
        return !!isPricingEnabled ? this.omsService.getPricingOffer(this.order) : this.$q.when();
      })
      .then((priceOffer) => {
        this.priceOffer = priceOffer;
        this.submitting = false;
        if (!priceOffer) {
          this._createOrder(this.order);
        } else if (!isValidServiceArea) {
          this.omsDialogService.validateServiceAreas()
            .then((editPrice) => {
              this.isPriceOfferEditMode = editPrice;
              if (!!editPrice) {
                this.orderCopy = angular.copy(this.order);
                this.priceOfferCopy = angular.copy(priceOffer);
              }
            })
        }
      })
  }

  private _onDuplicateOrder(saveAsDraft?) {
    this.submitting = true;
    this.omsService.validateOmsOrderServiceAreas(this.order)
      .then((isValid) => {
        this.submitting = false;
        if (isValid) {
          this._duplicateOrder(this.order, this.numberOfDuplicateCopies, saveAsDraft);
        } else {
          this.omsDialogService.validateServiceAreas(false);
        }
      })
  }

  private _createOrder(order, doDispatch?, priceOffer?) {
    this.submitting = true;
    this.bringozLoaderService.on();
    let createdOrderRef;
    const orderCopy = angular.copy(order);
    orderCopy.metaData = _.chain(orderCopy.metaData)
      .filter(item => {
        return item.value;
      })
      .map(item => {
        return {
          key: item.key,
          value: item.value
        }
      })
      .value();
    this.omsRequestsService.createOrder(orderCopy)
      .then((createdOrder) => {
        if (!this.isDialog) {
          this.omsOrdersAlertsService.createSuccess();
        }
        createdOrderRef = createdOrder;
        const priceOfferHasInitialPriceDetailLines = _.get(priceOffer, 'pricingDataInfos[0].priceDetails.initialPriceDetailLines');
        return (!!priceOffer && priceOfferHasInitialPriceDetailLines && this.isPriceOfferEditMode) ?
          this.billingOrderService.updatePrice(createdOrder.billingOrderId, priceOffer) : this.$q.when();
      })
      .then(() => {
        // if (this.siteInfo.allowAutoDispatch) {
        //   this.OmsService.autoDispatchOrder(createdOrderRef.id)
        // }
        this._onOrderCreated(createdOrderRef, doDispatch);
      })
      .catch((error) => {
        if (error.code === 412300) {
          this.omsDialogService.createOrderFailed()
            .then(() => {

            })
        } else if (error.code === 400411) {
          this._onOrderCreated(createdOrderRef, doDispatch);
        } else {
          this.omsOrdersAlertsService.createError(error);
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
        this.submitting = false;
      });
  }

  // In dialog mode the user stays on the current screen, unless dispatch was requested (handled by the order view)
  private _onOrderCreated(createdOrder, doDispatch?) {
    if (this.isDialog && !doDispatch) {
      this.onCreated({order: createdOrder, isDraft: false});
      return;
    }

    this.$state.go('order.info', {
      id: createdOrder.id,
      doDispatch: doDispatch,
      autoDispatch: this.siteInfo.allowAutoDispatch
    }, {notify: true, reload: false});

    if (this.isDialog) {
      this.onCancel();
    }
  }

  private _duplicateOrder(order, numberOfDuplicateCopies, saveAsDraft) {
    this.submitting = true;
    order.metaData = _.chain(order.metaData)
      .filter(item => {
        return item.value;
      })
      .map(item => {
        return {
          key: item.key,
          value: item.value
        }
      })
      .value();
    this.omsRequestsService.createMultipleOrders(order, numberOfDuplicateCopies, saveAsDraft)
      .then((res) => {
        this.omsOrdersAlertsService.createSuccess();
        this.$state.go('orders.table');
      })
      .catch((error) => {
        this.omsOrdersAlertsService.createError(error);
      })
      .finally(() => {
        this.submitting = false;
      });
  }

}

angular
  .module('bringoz.admin.oms')
  .component('omsOrderCreateView', {
    bindings: {
      order: '<?',
      account: '<',
      isDialog: '<?',
      isPrefilled: '<?',
      onCreated: '&?',
      onCancel: '&?',
      onAdvanced: '&?'
    },
    template: require('./oms-order-create-view.html').default,
    controller: OmsOrderCreateViewComponent
  });
